export default __webpack_public_path__ + "static/media/p-tools.43fe648c.png";